import React from 'react';

const defaultView = ({ event }) => (
  <div className="event">
    <h3>{event.title}</h3>
    <h4>{`#(${event.id})`}</h4>

    <div>
      <span>{event.homeTeam}</span>
      <span>@</span>
      <span>{event.awayTeam}</span>
    </div>

    <div className="ui divider" />

    <div>{event.state}</div>
  </div>
);

export default defaultView;
